// @core/api/endpoints/platform/get_data_residency_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DataResidencyPolicyResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Get data residency policy
 * Retrieves the platform's data residency policy including region, allowed cross-border data flows, and compliance framework.
 */
export async function GetDataResidencyPolicy(
  platform_id: string,
  options?: RequestOptions
): Promise<DataResidencyPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/data-residency`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.get<DataResidencyPolicyResponse>(requestPath, { ...requestOptions });
}
